import { useAuth } from "../context/AuthContext";
import { isSubscriptionFunctionalityOff } from "../utils/subscriptionAccess";
import {
  canAccessRoute,
  getTeacherPermissions,
  isRouteAllowedWhenTemaInactive,
} from "./temaRoutePermissions";
import { RouteFallback } from "./RouteFallback";

export function ProtectedRoute({ route, children }) {
  const { isAuthenticated, subscription } = useAuth();
  const permissions = getTeacherPermissions(isAuthenticated);

  if (!route) {
    return <RouteFallback kind="not-found" />;
  }

  if (route.id === "not-found") {
    return <RouteFallback kind="not-found" hash={window.location.hash} />;
  }

  if (
    !canAccessRoute(route, { isAuthenticated, permissions, subscription })
  ) {
    const inactiveSubscription =
      !isSubscriptionFunctionalityOff() &&
      isAuthenticated &&
      subscription?.temaActive !== 1 &&
      !isRouteAllowedWhenTemaInactive(route?.id);
    return (
      <RouteFallback
        kind={
          inactiveSubscription
            ? "subscription-inactive"
            : isAuthenticated
              ? "unauthorized"
              : "auth-required"
        }
        routeLabel={route.breadcrumbs?.at(-1)?.label}
      />
    );
  }

  return children;
}
